module.exports = __webpack_public_path__ + "img/9788980403189.05204066.jpg";